<template>
    <header class="tsi-header">
        <div class="tsi-container tsi-header__inner">
            <img class="tsi-header__mark" src="/assets/images/tsi-mark.png" alt="TSI"/>
            <div class="tsi-header__titles">
                <div class="tsi-header__cn">{{ appName }}</div>
                <div class="tsi-header__en">TSI · Video Conference Management Platform</div>
            </div>
            <div class="tsi-header__spacer"></div>
            <div class="tsi-header__rule"></div>
            <div class="tsi-header__clock">
                <div class="tsi-header__time">{{ clock }}</div>
                <div class="tsi-header__date">{{ today }}</div>
            </div>
        </div>
    </header>
</template>

<script>
import {mapState} from "vuex";

const pad = n => String(n).padStart(2, '0');

export default {
    name: "tsi-header",
    data() {
        return {
            now: new Date(),
        }
    },
    computed: {
        ...mapState(['preset']),
        appName() {
            return (this.preset.app && this.preset.app.name) || '韬视视频会议管理系统';
        },
        clock() {
            return pad(this.now.getHours()) + ':' + pad(this.now.getMinutes());
        },
        today() {
            const d = this.now;
            return d.getFullYear() + '年' + pad(d.getMonth() + 1) + '月' + pad(d.getDate())
                + '日 星期' + '日一二三四五六'[d.getDay()];
        },
    },
    mounted() {
        this.timer = setInterval(() => {
            this.now = new Date();
        }, 10000);
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
}
</script>
